import React from "react";
import { Box, Drawer } from "@mui/material";
import SidebarContent from "./SidebarContent";

const Mobilesidebar = () => {
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation">
      <Box
        sx={{
          padding: "14px",
          marginTop: "20px",
        }}
      >
        <SidebarContent />
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        justifyContent: "flex-start",
        textAlign: "left",
        paddingLeft: 0,
        display: { xs: "block", sm: "none", md: "none" },
      }}
    >
      {/* <Button onClick={toggleDrawer(true)}>
        <EditNoteTwoToneIcon sx={{ width: '34px', height: '34px' }} />
      </Button> */}
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </Box>
  );
};

export default Mobilesidebar;
